export default "__VITE_ASSET__akhQPaxP__"